import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { calculateRequiredTiers, estimateCostUsd, getSkuTierDisplayName } from "./utils";
import { SelectedFields } from "./types";

interface SkuSummaryProps {
  selectedFields: SelectedFields;
}

export const SkuSummary: React.FC<SkuSummaryProps> = ({ selectedFields }) => {
  const tiers = calculateRequiredTiers(selectedFields);
  const cost = estimateCostUsd(tiers);

  if (tiers.length === 0) {
    return null;
  }

  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ bgcolor: "grey.50", p: 2, borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          消費するSKU
        </Typography>
        <Typography variant="body1" gutterBottom>
          {tiers.map(getSkuTierDisplayName).join(" + ")}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          想定コスト: 約{cost.toFixed(3)}USD
        </Typography>
        <Typography variant="caption" color="text.secondary">
          ※ 表示金額は目安です。
        </Typography>
      </Box>
    </>
  );
};
